import {
    ADD_MESSAGE,
    USER_TYPING,
    ASSISTANT_RESPONDING,
    ADD_BULK_MESSAGE,
    DELETE_ALL_MESSAGES,
    SET_HAS_INITIALIZED_MESSAGES,
    ADD_SELECTED_VALUE,
    REMOVE_SELECTED_VALUE,
    REMOVE_ALL_SELECTED_VALUE,
    DELETE_MESSAGES_KEEPING_INITIAL,
    APPEND_TO_LAST_MESSAGE,
    ADD_ERROR_MESSAGE,
    CLEAR_ERROR_MESSAGE,
    TOGGLE_CHAT_VISIBILITY,
    ADD_REPORT,
    SET_ACTIVE_REPORT,
    LOAD_REPORTS,
    SET_CHAT_EXPANDED,
    SET_TASK_STATUS_MESSAGE,
    SHOW_CITATIONS,
    HIDE_CITATIONS,
    CLEAR_CITATIONS,
    SET_HISTORY_METADATA,
    CLEAR_HISTORY_METADATA,
    UPDATE_REPORT_MESSAGE,
    DELETE_REPORT_SECTION,
    REORDER_REPORT_SECTIONS,
    MOVE_SECTION_UP,
    MOVE_SECTION_DOWN,
    ADD_NEW_SECTION_INPUT,
    REMOVE_NEW_SECTION_INPUT,
    ADD_NEW_SECTION_START,
    ADD_NEW_SECTION_SUCCESS,
    ADD_NEW_SECTION_FAILURE,
    SAVE_NEW_SECTION_START,
    SAVE_NEW_SECTION_SUCCESS,
    SAVE_NEW_SECTION_FAILURE,
    ENTER_SECTION_EDIT_MODE,
    EXIT_SECTION_EDIT_MODE,
    REVISE_SECTION_DRAFT_START,
    REVISE_SECTION_DRAFT_SUCCESS,
    REVISE_SECTION_DRAFT_FAILURE,
    SAVE_SECTION_EDIT_START,
    SAVE_SECTION_EDIT_SUCCESS,
    SAVE_SECTION_EDIT_FAILURE,
} from "./actionTypes";
import { buildAssistantHeaders, buildAssistantUrl } from "../utils/assistantApi";

export const addMessage = (message) => ({
    type: ADD_MESSAGE,
    payload: message,
});

export const addBulkMessage = (message) => ({
    type: ADD_BULK_MESSAGE,
    payload: message,
});

export const userTyping = (isTyping) => ({
    type: USER_TYPING,
    payload: isTyping,
});

export const assistantResponding = (isResponding) => ({
    type: ASSISTANT_RESPONDING,
    payload: isResponding,
});

export const deleteAllMessage = () => ({
    type: DELETE_ALL_MESSAGES,
});

export const setHasInitializedMessages = (hasInitialized) => ({
    type: SET_HAS_INITIALIZED_MESSAGES,
    payload: hasInitialized,
});

export const addSelectedValue = (value) => ({
    type: ADD_SELECTED_VALUE,
    payload: value,
});

export const removeSelectedValue = (value) => ({
    type: REMOVE_SELECTED_VALUE,
    payload: value,
});

export const removeAllSelectedValues = () => ({
    type: REMOVE_ALL_SELECTED_VALUE,
});

export const deleteMessagesKeepingInitial = (index) => ({
    type: DELETE_MESSAGES_KEEPING_INITIAL,
    payload: index,
});
export const appendToLastMessage = (textChunk) => ({
    type: APPEND_TO_LAST_MESSAGE,
    payload: textChunk,
});

export const addErrorMessage = (textChunk) => ({
    type: ADD_ERROR_MESSAGE,
    payload: textChunk,
});

export const clearErrorMessage = () => ({
    type: CLEAR_ERROR_MESSAGE
});

export const toggleChatVisibility = (isOpen) => ({
    type: TOGGLE_CHAT_VISIBILITY,
    payload: isOpen,
});

export const addReport = (report) => ({
    type: ADD_REPORT,
    payload: report,
});

export const setActiveReport = (reportId) => ({
    type: SET_ACTIVE_REPORT,
    payload: reportId,
});

export const loadReports = (reports) => ({
    type: LOAD_REPORTS,
    payload: reports,
});

export const setChatExpanded = (value) => ({
    type: SET_CHAT_EXPANDED,
    payload: value,
});

export const setTaskStatusMessage = (value) => ({
    type: SET_TASK_STATUS_MESSAGE,
    payload: value
})

export const showCitations = (sources) => ({
    type: SHOW_CITATIONS,
    payload: sources,
});

export const hideCitations = () => ({
    type: HIDE_CITATIONS,
});

export const clearCitations = () => ({
    type: CLEAR_CITATIONS,
});

export const setHistoryMetadata = (metadata) => ({
    type: SET_HISTORY_METADATA,
    payload: metadata,
});

export const clearHistoryMetadata = () => ({
    type: CLEAR_HISTORY_METADATA,
});

export const updateReportMessage = (report_id, updatedData) => ({
    type: UPDATE_REPORT_MESSAGE,
    payload: { report_id, updatedData },
});

export const enterSectionEditMode = (reportId, sectionId) => ({
    type: ENTER_SECTION_EDIT_MODE,
    payload: { reportId, sectionId },
});

export const requestSectionRevision = (reportId, sectionId, userQuery, draftId) => async (dispatch) => {
    dispatch({
        type: REVISE_SECTION_DRAFT_START,
        payload: { reportId, sectionId, draftId },
    });
    try {
        const response = await fetch(
            buildAssistantUrl("revise-section/"),
            {
                method: "POST",
                headers: buildAssistantHeaders(),
                credentials: "include",
                body: JSON.stringify({ reportId, sectionId, userQuery, draftId }),
            },
        );

        if (!response.ok) {
            throw new Error(response.statusText || "Server error");
        }

        const { draftId: nextDraftId, candidateSection, turns } = await response.json();
        dispatch({
            type: REVISE_SECTION_DRAFT_SUCCESS,
            payload: {
                reportId,
                sectionId,
                draftId: nextDraftId,
                previousDraftId: draftId,
                candidateSection,
                turns,
            },
        });
    } catch (error) {
        dispatch({
            type: REVISE_SECTION_DRAFT_FAILURE,
            payload: { reportId, sectionId, error: error.message },
        });
    }
};

export const commitSectionRevision = (reportId, sectionId, draftId) => async (dispatch) => {
    dispatch({
        type: SAVE_SECTION_EDIT_START,
        payload: { reportId, sectionId, draftId },
    });
    try {
        const response = await fetch(
            buildAssistantUrl("revise-section-commit/"),
            {
                method: "POST",
                headers: buildAssistantHeaders(),
                credentials: "include",
                body: JSON.stringify({ reportId, sectionId, draftId }),
            },
        );

        if (!response.ok) {
            throw new Error(response.statusText || "Server error");
        }

        const { updatedSection } = await response.json();
        dispatch({
            type: SAVE_SECTION_EDIT_SUCCESS,
            payload: { reportId, sectionId, draftId, updatedSection },
        });
    } catch (error) {
        dispatch({
            type: SAVE_SECTION_EDIT_FAILURE,
            payload: { reportId, sectionId, draftId, error: error.message },
        });
    }
};

export const discardSectionRevision = (reportId, sectionId, draftId) => async (dispatch) => {
    try {
        if (draftId) {
            await fetch(
                buildAssistantUrl("revise-section-discard/"),
                {
                    method: "POST",
                    headers: buildAssistantHeaders(),
                    credentials: "include",
                    body: JSON.stringify({ reportId, sectionId, draftId }),
                },
            );
        }
    } catch (error) {
        console.error("Failed to discard section revision", error);
    }

    dispatch({
        type: EXIT_SECTION_EDIT_MODE,
        payload: { reportId, sectionId },
    });
};

export const deleteReportSection = (reportId, sectionId) => ({
    type: DELETE_REPORT_SECTION,
    payload: { reportId, sectionId },
});

export const reorderReportSections = (reportId, newSections) => ({
    type: REORDER_REPORT_SECTIONS,
    payload: { reportId, newSections },
});

export const moveSectionUp = (reportId, sectionId) => ({
    type: MOVE_SECTION_UP,
    payload: { reportId, sectionId },
});

export const moveSectionDown = (reportId, sectionId) => ({
    type: MOVE_SECTION_DOWN,
    payload: { reportId, sectionId },
});

export const addNewSectionInput = (reportId, afterSectionId) => ({
    type: ADD_NEW_SECTION_INPUT,
    payload: { reportId, afterSectionId },
});

export const removeNewSectionInput = (reportId, draftId, afterSectionId) => async (dispatch) => {
    try {
        if (draftId) {
            await fetch(
                buildAssistantUrl("add-section-discard/"),
                {
                    method: "POST",
                    headers: buildAssistantHeaders(),
                    credentials: "include",
                    body: JSON.stringify({ reportId, draftId }),
                },
            );
        }
    } catch (error) {
        console.error("Failed to discard add-section draft", error);
    }

    dispatch({
        type: REMOVE_NEW_SECTION_INPUT,
        payload: { reportId, draftId, afterSectionId },
    });
};

export const addNewSection = (reportId, userQuery, afterSectionId, draftId) => async (dispatch) => {
    dispatch({
        type: ADD_NEW_SECTION_START,
        payload: { reportId, afterSectionId, draftId },
    });
    try {
        const response = await fetch(
            buildAssistantUrl("add-section/"),
            {
                method: "POST",
                headers: buildAssistantHeaders(),
                credentials: "include",
                body: JSON.stringify({ reportId, userQuery, afterSectionId, draftId }),
            },
        );

        if (!response.ok) {
            throw new Error(response.statusText || "Server error");
        }

        const { draftId: nextDraftId, candidateSection, turns } = await response.json();
        dispatch({
            type: ADD_NEW_SECTION_SUCCESS,
            payload: {
                reportId,
                draftId: nextDraftId,
                previousDraftId: draftId,
                candidateSection,
                afterSectionId,
                turns,
            },
        });
    } catch (error) {
        dispatch({
            type: ADD_NEW_SECTION_FAILURE,
            payload: { reportId, error: error.message, afterSectionId, draftId },
        });
    }
};

export const saveNewSection = (reportId, draftId, afterSectionId) => async (dispatch) => {
    dispatch({
        type: SAVE_NEW_SECTION_START,
        payload: { reportId, draftId, afterSectionId },
    });

    try {
        const response = await fetch(
            buildAssistantUrl("add-section-commit/"),
            {
                method: "POST",
                headers: buildAssistantHeaders(),
                credentials: "include",
                body: JSON.stringify({ reportId, draftId, afterSectionId }),
            },
        );

        if (!response.ok) {
            throw new Error(response.statusText || "Server error");
        }

        const { newSection } = await response.json();
        dispatch({
            type: SAVE_NEW_SECTION_SUCCESS,
            payload: { reportId, draftId, afterSectionId, newSection },
        });
    } catch (error) {
        dispatch({
            type: SAVE_NEW_SECTION_FAILURE,
            payload: { reportId, draftId, afterSectionId, error: error.message },
        });
    }
};
